/**
 * 个股详情信息Tab（成分股、报价、股吧、盘口、资讯、公告、研报、财务、必读）
 */
import React, { useEffect, useState } from "react"
import { quotedata } from "../quotedata"
import "./index.less"
import { GuBa } from "../../shared/guba"
import { StockInfo, StockNotice, StockReport } from "../../shared/stock_info"
import { PageBondType, PageType, StockSubType } from "../pagetype"
import { getStockKind } from "../utils"
import { StockPanKou } from "../stock_info/components/stock_pankou"
import { store as AStore } from "../../page/a/store"
import { store as ZSStore } from "../../page/zs/store"
import { store as BStore } from "../../page/b/store"
import { store as TipsStore } from "../../page/tips/store"
import { Observer } from "mobx-react-lite"
import { ConstituentStock } from "../stock_info/components/constituent_stock_sse"
import { Quotation } from "../stock_info/components/quotation"
import { GlobalIndexConstituentStock } from "../stock_info/components/constituent_stock_index"
import { IndexConstituentStockSSE } from "../stock_info/components/constituent_stock_index_sse"
import { TipsRelevantType } from "../stock_info/components/relevant_type"

export function StockInfoTabs(props: { showTabs: Array<string>; quotedata: quotedata; pagetype: PageType; _market?: any; stocksubtype?: StockSubType; bondsubtype?: PageBondType }) {
  const [tabs, setTabs] = useState<Array<{ id: string; name: string; selected: boolean }>>([])
  const [selectedTab, setSelectedTab] = useState("")
  const tabArr = [
    {
      id: "xgpz",
      name: "相关品种",
      selected: false,
    },
    {
      id: "cfg",
      name: "成分股",
      selected: false,
    },
    {
      id: "bj",
      name: "报价",
      selected: false,
    },
    {
      id: "gb",
      name: "股吧",
      selected: false,
    },
    {
      id: "pk",
      name: "盘口",
      selected: false,
    },
    {
      id: "zx",
      name: "资讯",
      selected: false,
    },
    {
      id: "gg",
      name: "公告",
      selected: false,
    },
    {
      id: "yb",
      name: "研报",
      selected: false,
    },
    {
      id: "cw",
      name: "财务",
      selected: false,
    },
    {
      id: "bd",
      name: "必读",
      selected: false,
    },
  ]

  const selectInfoTab = (item: { id: string; name: string; selected: boolean }) => {
    setSelectedTab(item.id)
    let temp = tabs.map((item) => {
      item.selected = false
      return item
    })
    item.selected = true
    setTabs(temp)
    renderTab(item.id)
  }

  useEffect(() => {
    if (props.showTabs.length) {
      let arr = tabArr.filter((v: any) => props.showTabs.some((item: any) => item == v.name))
      if (props.pagetype == PageType.沪深京指数 || props.pagetype == PageType.全球指数 || props.pagetype == PageType.choice指数 || props.pagetype == PageType.国证指数) {
        let temp = arr.shift()
        temp && arr.push(temp)
      }
      arr[0].selected = true
      setSelectedTab(arr[0].id)
      setTabs(arr)
    }
  }, [])

  const renderTab = (currentTab: string) => {
    if (currentTab == "bd") {
      if (props.pagetype == PageType.英股) {
        // 英股
        location.href = "https://emh5.eastmoney.com/uk/index.html?fc=" + props.quotedata.code + "&color=w#/cpbd"
      } else if (props.pagetype == PageType.美股) {
        // 美股
        let houzhui = ""
        if (props.quotedata.market == 107) {
          houzhui = ".A"
        } else if (props.quotedata.market == 106) {
          houzhui = ".N"
        } else if (props.quotedata.market == 105) {
          houzhui = ".O"
        }
        location.href = "https://emh5.eastmoney.com/us/index.html?fc=" + props.quotedata.code + houzhui + "&color=w#/cpbd"
      } else if (props.pagetype == PageType.港股) {
        // 港股
        location.href = "https://emh5.eastmoney.com/HK/index.html?fc=" + props.quotedata.code + "&color=w#/cpbd"
      } else if (props._market && props._market.f107 == 150) {
        //场外基金
        location.href = `https://emh5.eastmoney.com/jjf10/index.html?fc=${props.quotedata.code}.OF&color=w#/index`
      }
      // 沪深
      if (props._market && (props._market.f107 == 0 || props._market.f107 == 1)) {
        if ((props._market.f107 == 1 && props._market.f111 == 9) || (props._market.f107 == 0 && props._market.f111 == 10)) {
          //沪深场内基金
          location.href = "https://emh5.eastmoney.com/hscnf10/html/index.html?fc=" + props.quotedata.code + getStockKind(props.quotedata.market.toString()) + "&color=w#/index"
        } else if (props.bondsubtype == PageBondType.上证可转债 || props.bondsubtype == PageBondType.深证可转债) {
          // 退市到三板
          if (props._market.f107 == 0 && props._market.f181 & 2) {
            location.href = "https://emh5.eastmoney.com/change/index.html?fc=" + props.quotedata.code + ".NQ&color=w#/cpbd"
          } else {
            location.href = "https://emh5.eastmoney.com/change/index.html?fc=" + props.quotedata.code + getStockKind(props.quotedata.market.toString()) + "&color=w#/jbxx"
          }
        } else if (props._market.f107 == 0 && props.stocksubtype == StockSubType.北证A股) {
          // 北交所
          location.href = "https://emh5.eastmoney.com/html/?fc=" + props.quotedata.code + ".BJ&color=w#/cpbd"
        } else if (props._market.f107 == 0 && props._market.f111 == 81) {
          //三板
          location.href = "https://emh5.eastmoney.com/SanBan/html/index.html?fc=" + props.quotedata.code + ".OC&color=w#/cpbd"
        } else {
          //一般沪深
          location.href = "https://emh5.eastmoney.com/html/?fc=" + props.quotedata.code + getStockKind(props.quotedata.market.toString()) + "&color=w#/cpbd"
        }
      }
    }
    if (currentTab == "cw") {
      if (props._market && (props._market.f107 == 0 || props._market.f107 == 1)) {
        // 沪深
        if ((props._market.f107 == 1 && props._market.f111 == 9) || (props._market.f107 == 0 && props._market.f111 == 10)) {
          // 沪深场内基金
          location.href = "https://emh5.eastmoney.com/hscnf10/html/index.html?fc=" + props.quotedata.code + getStockKind(props.quotedata.market.toString()) + "&color=w#/index"
        } else if (props.bondsubtype == PageBondType.上证可转债 || props.bondsubtype == PageBondType.深证可转债) {
          // 沪深可转债
          location.href = "https://emh5.eastmoney.com/change/index.html?fc=" + props.quotedata.code + getStockKind(props.quotedata.market.toString()) + "&color=w#/jbxx"
        } else if (props._market.f107 == 0 && props.stocksubtype == StockSubType.北证A股) {
          // 北交所
          location.href = "https://emh5.eastmoney.com/html/?fc=" + props.quotedata.code + ".BJ&color=w#/cwfx"
        } else if (props._market.f107 == 0 && props._market.f111 == 81) {
          // 三板
          location.href = "https://emh5.eastmoney.com/SanBan/html/index.html?fc=" + props.quotedata.code + ".OC&color=w#/cwfx"
        } else {
          // 一般沪深
          location.href = "https://emh5.eastmoney.com/html/?fc=" + props.quotedata.code + getStockKind(props.quotedata.market.toString()) + "&color=w#/cwfx"
        }
      } else if (props.pagetype == PageType.美股) {
        // 美股
        let houzhui = ""

        if (props._market) {
          if (props._market.f107 == 107) {
            houzhui = ".A"
          } else if (props._market.f107 == 106) {
            houzhui = ".N"
          } else if (props._market.f107 == 105) {
            houzhui = ".O"
          }
        }
        location.href = "https://emh5.eastmoney.com/us/index.html?fc=" + props.quotedata.code + houzhui + "&color=w#/cwfx"
      } else if (props.pagetype == PageType.港股) {
        //港股
        location.href = "https://emh5.eastmoney.com/HK/index.html?fc=" + props.quotedata.code + "&color=w#/cwfx"
      } else if (props.pagetype == PageType.英股) {
        //英股
        location.href = "https://emh5.eastmoney.com/uk/index.html?fc=" + props.quotedata.code + "&color=w#/cwfx"
      } else if (props._market && props._market.f107 == 150) {
        //场外基金
        location.href = "https://emh5.eastmoney.com/jjf10/index.html?fc=" + props.quotedata.code + ".OF&color=w#/index"
      }
    }
  }

  return (
    <>
      <ul className="comm-tabs info-tabs">
        {tabs.length > 0 &&
          tabs.map((item: any) => {
            return (
              <li
                key={item.id}
                className={`${item.selected ? "active" : ""} ${tabs.length == 1 ? "single-tab" : ""}`}
                onClick={(e) => {
                  e.preventDefault()
                  selectInfoTab(item)
                }}
              >
                <a href="#">{item.name}</a>
              </li>
            )
          })}
      </ul>
      {selectedTab == "xgpz" && (props.stocksubtype == StockSubType.中国关键期国债 || props.stocksubtype == StockSubType.美国关键期国债 || props.stocksubtype == StockSubType.全球关键期国债) && <WrapTipsRelevantType quotename={props.quotedata.name} />}
      {selectedTab == "bj" && <Quotation quotecode={props.quotedata.quotecode} />}
      {props.pagetype == PageType.板块 && selectedTab == "cfg" && <ConstituentStock quotecode={props.quotedata.code} />}
      {props.pagetype == PageType.全球指数 && selectedTab == "cfg" && <GlobalIndexConstituentStock quotecode={props.quotedata.quotecode} />}
      {(props.pagetype == PageType.沪深京指数 || props.pagetype == PageType.choice指数 || props.pagetype == PageType.国证指数) && selectedTab == "cfg" && <IndexConstituentStockSSE quotecode={props.quotedata.quotecode} />}
      {selectedTab == "gb" && <GuBa quotecode={props.quotedata.quotecode} pagetype={props.pagetype}/>}
      {selectedTab == "zx" && <StockInfo quotedata={props.quotedata} />}
      {selectedTab == "gg" && <StockNotice quotedata={props.quotedata} />}
      {selectedTab == "yb" && <StockReport quotedata={props.quotedata} />}
      {selectedTab == "pk" && props.pagetype == PageType.沪深A股 && <WrapAPanKou quotecode={props.quotedata.quotecode} pagetype={props.pagetype} stocksubtype={props.stocksubtype!} />}
      {selectedTab == "pk" && (props.stocksubtype == StockSubType.沪市指数 || props.pagetype == PageType.choice指数) && <WrapZSPanKou quotecode={props.quotedata.quotecode} pagetype={props.pagetype} stocksubtype={props.stocksubtype!} />}
      {selectedTab == "pk" && props.pagetype == PageType.B股 && <WrapBPanKou quotecode={props.quotedata.quotecode} pagetype={props.pagetype} stocksubtype={props.stocksubtype!} />}
    </>
  )
}

function WrapAPanKou(props: { quotecode: string; pagetype: PageType; stocksubtype: StockSubType }) {
  return <Observer>{() => <StockPanKou data={AStore.StockDetail} quotecode={props.quotecode} pagetype={props.pagetype} stocksubtype={props.stocksubtype} />}</Observer>
}

function WrapZSPanKou(props: { quotecode: string; pagetype: PageType; stocksubtype: StockSubType }) {
  return <Observer>{() => <StockPanKou data={ZSStore.StockDetail} quotecode={props.quotecode} pagetype={props.pagetype} stocksubtype={props.stocksubtype} />}</Observer>
}

function WrapBPanKou(props: { quotecode: string; pagetype: PageType; stocksubtype: StockSubType }) {
  return <Observer>{() => <StockPanKou data={BStore.StockDetail} quotecode={props.quotecode} pagetype={props.pagetype} stocksubtype={props.stocksubtype} />}</Observer>
}

function WrapTipsRelevantType(props: { quotename: string }) {
  let inflation = "+s:!1"
  if (props.quotename && props.quotename.indexOf("通胀") > -1) {
    inflation = "+s:1"
  }
  return <Observer>{() => <>{TipsStore.StockDetail && <TipsRelevantType countryCode={TipsStore.StockDetail.f753} duration={TipsStore.StockDetail.f754} inflation={inflation} />}</>}</Observer>
}
